import { useLocation } from 'react-router-dom';

import PreScreeningForm from '@/pages/PreScreeningForms/PreScreeningForm';
import { PreScreeningFormShortPage } from './PreScreeningFormShortPage';

export const PreScreeningFormVariants = () => {
  const { search } = useLocation();
  const display = new URLSearchParams(search).get('display');

  if (display === 'long') {
    return <PreScreeningForm />;
  }

  if (display === 'short') {
    // headerless variant for use in iFrames
    return <PreScreeningFormShortPage pageWrapper={false} />;
  }

  return <PreScreeningFormShortPage />;
};
